'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CalendarEmpty;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function CalendarEmpty(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
      'aria-hidden': true,
      className: 'icon-svg-calendar-empty ' + className,
      width: width,
      height: height,
      viewBox: '0 0 16 16' },
    _react2.default.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('rect', { stroke: color, width: '12.5', height: '12.5', x: '1.75', y: '2.75', strokeWidth: '1.5', rx: '1.5' }),
      _react2.default.createElement('path', { fill: color, d: 'M5.69999999,3 L10.3,3 C10.1343146,3 10,2.86568542 10,2.69999999 L10,0.300000012 C10,0.13431458 10.1343146,3.043592e-17 10.3,0 L11.7,0 C11.8656854,-3.043592e-17 12,0.13431458 12,0.300000012 L12,2.69999999 C12,2.86568542 11.8656854,3 11.7,3 L14,3 L14,5 L2,5 L2,3 L4.30000001,3 C4.13431458,3 4,2.86568542 4,2.69999999 L4,0.300000012 C4,0.13431458 4.13431458,3.043592e-17 4.30000001,0 L5.69999999,0 C5.86568542,-3.043592e-17 6,0.13431458 6,0.300000012 L6,2.69999999 C6,2.86568542 5.86568542,3 5.69999999,3 Z' })
    )
  );
}

CalendarEmpty.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/icons/lib/components/CalendarEmpty/CalendarEmpty.js
// module id = 135
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14